import { render, staticRenderFns } from "./MdopPartList.vue?vue&type=template&id=523e173c&scoped=true&"
import script from "./MdopPartList.vue?vue&type=script&lang=js&"
export * from "./MdopPartList.vue?vue&type=script&lang=js&"
import style0 from "./MdopPartList.vue?vue&type=style&index=0&id=523e173c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523e173c",
  null
  
)

export default component.exports